import {useCallback} from 'react'
import useOcapiSite from './useOcapiSite'
import {useCurrentCustomer} from './use-current-customer'
import {isD2BCustomer} from '../utils/d2b-utils'

const useDoubleOptIn = () => {
    const {customPreferences, d2bEnabled} = useOcapiSite()
    const {data: customer} = useCurrentCustomer()

    const isDoubleOptInEnabled = useCallback(
        (email) => {
            if (isD2BCustomer(d2bEnabled, customer)) {
                return false
            }
            if (email && customPreferences.doubleOptInMailDomains) {
                const emailDomain = email.substring(email.indexOf('@') + 1)
                if (customPreferences.doubleOptInMailDomains.includes(emailDomain)) {
                    return true
                }
            }
            return customPreferences.doubleOptInEnabled
        },
        [
            customPreferences.doubleOptInMailDomains,
            customPreferences.doubleOptInEnabled,
            d2bEnabled,
            customer
        ]
    )

    return {isDoubleOptInEnabled}
}
export default useDoubleOptIn
